"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenuItem = void 0;
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Grow_1 = __importDefault(require("@material-ui/core/Grow"));
const Icon_1 = __importDefault(require("@material-ui/core/Icon"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ListItemSecondaryAction_1 = __importDefault(require("@material-ui/core/ListItemSecondaryAction"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Popper_1 = __importDefault(require("@material-ui/core/Popper"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const PlayArrow_1 = __importDefault(require("@material-ui/icons/PlayArrow"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const menu_styles_1 = require("./menu-styles");
function SubMenuItem({ item, index, opened, onHover, classOverrides, SubMenuComponent, }) {
    var _a, _b, _c, _d;
    const classes = (0, menu_styles_1.useStyles)();
    const anchorEl = (0, react_1.useRef)(null);
    const handleMouseEnter = (0, event_callback_hook_1.useEventCallback)(() => {
        onHover(index);
    });
    const keyShortcut = (_a = item.keyShortcutLabel) !== null && _a !== void 0 ? _a : item.keyShortcut;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MenuItem_1.default, { component: item.href ? 'a' : 'div', href: item.href, onClick: (e) => {
                e.preventDefault();
                if (item.onClick) {
                    item.onClick();
                }
                else {
                    // do not close submenu if there is no onClick provided
                    e.stopPropagation();
                }
            }, onMouseEnter: handleMouseEnter, className: (0, clsx_1.default)(classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.subMenuItem), classes: { root: classes.subMenuItem }, ref: anchorEl },
            react_1.default.createElement(ListItemIcon_1.default, { classes: { root: (0, clsx_1.default)(classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.subMenuItemIcon) } }, item.icon && react_1.default.createElement(Icon_1.default, null, item.icon)),
            react_1.default.createElement(Typography_1.default, { variant: "inherit", className: (0, clsx_1.default)(classes.subMenuItemText, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.subMenuItemText) }, item.label),
            react_1.default.createElement(ListItemSecondaryAction_1.default, { className: (0, clsx_1.default)(classes.subMenuAction, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.subMenuAction) },
                keyShortcut && (react_1.default.createElement("span", { className: classes.shortcut }, keyShortcut)),
                ((_c = (_b = item.items) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0 && (react_1.default.createElement(PlayArrow_1.default, { className: (0, clsx_1.default)(classes.subMenuArrow, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.subMenuArrow) })))),
        ((_d = item.items) === null || _d === void 0 ? void 0 : _d.length) && (react_1.default.createElement(Popper_1.default, { open: opened, anchorEl: anchorEl.current, placement: "right-start", style: { zIndex: 1050 }, transition: true, container: document.getElementById('menu-bar') }, ({ TransitionProps }) => (react_1.default.createElement(Grow_1.default, { ...TransitionProps, style: { transformOrigin: '0 0 0' } },
            react_1.default.createElement(SubMenuComponent, { items: item.items, opened: opened, classOverrides: classOverrides })))))));
}
exports.SubMenuItem = SubMenuItem;
//# sourceMappingURL=sub-menu-item.js.map